import React from "react";
import { Image } from "antd";
import { StyledErrorPage } from "./ErrorStyledComponent";
import { CustomTitle, FlexWrap } from "../StyledComponent";

function Index() {
  return (
    <StyledErrorPage>
      <Image preview={false} src='/images/error-state.svg' />
      <FlexWrap flexDir='column'>
        <CustomTitle fontSize={18} lineheight={28} color='#0e121b'>
          Page not found
        </CustomTitle>
      </FlexWrap>
    </StyledErrorPage>
  );
}

export default Index;
